export const result = {
  header: {
    uri: 'https://api.os.uk/search/places/v1/find?query=baker%20street',
    query: 'query=baker street',
    offset: 0,
    totalresults: 10,
    format: 'JSON',
    dataset: 'DPA',
    lr: 'EN,CY',
    maxresults: 100,
    matchprecision: 1,
    epoch: '121',
    lastupdate: '2025-10-14',
    output_srs: 'EPSG:27700'
  },
  results: [
    {
      DPA: {
        UPRN: '250034655',
        UDPRN: '1216958',
        ADDRESS: 'BAKER STREET COTTAGE, BAKER STREET, FROME, BA11 3BL',
        BUILDING_NAME: 'BAKER STREET COTTAGE',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'FROME',
        POSTCODE: 'BA11 3BL',
        RPC: '1',
        X_COORDINATE: 377184.0,
        Y_COORDINATE: 148060.0,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'RD04',
        CLASSIFICATION_CODE_DESCRIPTION: 'Terraced',
        LOCAL_CUSTODIAN_CODE: 3300,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'SOMERSET',
        COUNTRY_CODE: 'E',
        COUNTRY_CODE_DESCRIPTION: 'This record is within England',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000015533989',
        WARD_CODE: 'E05014362',
        PARISH_CODE: 'E04008560',
        LAST_UPDATE_DATE: '31/03/2023',
        ENTRY_DATE: '29/03/2000',
        BLPU_STATE_DATE: '29/03/2000',
        LANGUAGE: 'EN',
        MATCH: 0.4,
        MATCH_DESCRIPTION: 'NO MATCH',
        DELIVERY_POINT_SUFFIX: '1L'
      }
    },
    {
      DPA: {
        UPRN: '10033336368',
        UDPRN: '52500297',
        ADDRESS: 'BAKER STREET CINEMA, BAKER STREET, ABERGAVENNY, NP7 5BB',
        ORGANISATION_NAME: 'BAKER STREET CINEMA',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'ABERGAVENNY',
        POSTCODE: 'NP7 5BB',
        RPC: '2',
        X_COORDINATE: 329751.36,
        Y_COORDINATE: 214353.3,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'CL07CI',
        CLASSIFICATION_CODE_DESCRIPTION: 'Cinema',
        LOCAL_CUSTODIAN_CODE: 6840,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'MONMOUTHSHIRE',
        COUNTRY_CODE: 'W',
        COUNTRY_CODE_DESCRIPTION: 'This record is within Wales',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000021003409',
        WARD_CODE: 'W05001775',
        PARISH_CODE: 'W04001057',
        PARENT_UPRN: '10033345846',
        LAST_UPDATE_DATE: '25/02/2025',
        ENTRY_DATE: '11/11/2005',
        BLPU_STATE_DATE: '07/07/2010',
        LANGUAGE: 'EN',
        MATCH: 0.4,
        MATCH_DESCRIPTION: 'NO MATCH',
        DELIVERY_POINT_SUFFIX: '2A'
      }
    },
    {
      DPA: {
        UPRN: '10033336368',
        UDPRN: '52500297',
        ADDRESS: 'BAKER STREET CINEMA, BAKER STREET, Y FENNI, NP7 5BB',
        ORGANISATION_NAME: 'BAKER STREET CINEMA',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'Y FENNI',
        POSTCODE: 'NP7 5BB',
        RPC: '2',
        X_COORDINATE: 329751.36,
        Y_COORDINATE: 214353.3,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'CL07CI',
        CLASSIFICATION_CODE_DESCRIPTION: 'Cinema',
        LOCAL_CUSTODIAN_CODE: 6840,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'MONMOUTHSHIRE',
        COUNTRY_CODE: 'W',
        COUNTRY_CODE_DESCRIPTION: 'This record is within Wales',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000021003409',
        WARD_CODE: 'W05001775',
        PARISH_CODE: 'W04001057',
        PARENT_UPRN: '10033345846',
        LAST_UPDATE_DATE: '25/02/2025',
        ENTRY_DATE: '11/11/2005',
        BLPU_STATE_DATE: '07/07/2010',
        LANGUAGE: 'CY',
        MATCH: 0.4,
        MATCH_DESCRIPTION: 'NO MATCH',
        DELIVERY_POINT_SUFFIX: '2A'
      }
    },
    {
      DPA: {
        UPRN: '100100269282',
        UDPRN: '17105375',
        ADDRESS: '6, BAKER STREET, Y FENNI, NP7 5BB',
        BUILDING_NUMBER: '6',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'Y FENNI',
        POSTCODE: 'NP7 5BB',
        RPC: '2',
        X_COORDINATE: 329754.0,
        Y_COORDINATE: 214382.0,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'RD03',
        CLASSIFICATION_CODE_DESCRIPTION: 'Semi-Detached',
        LOCAL_CUSTODIAN_CODE: 6840,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'MONMOUTHSHIRE',
        COUNTRY_CODE: 'W',
        COUNTRY_CODE_DESCRIPTION: 'This record is within Wales',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000021003407',
        WARD_CODE: 'W05001775',
        PARISH_CODE: 'W04001057',
        LAST_UPDATE_DATE: '17/10/2016',
        ENTRY_DATE: '10/05/2001',
        BLPU_STATE_DATE: '06/09/2016',
        LANGUAGE: 'CY',
        MATCH: 0.4,
        MATCH_DESCRIPTION: 'NO MATCH',
        DELIVERY_POINT_SUFFIX: '1L'
      }
    },
    {
      DPA: {
        UPRN: '100100269283',
        UDPRN: '17105376',
        ADDRESS: '8, BAKER STREET, Y FENNI, NP7 5BB',
        BUILDING_NUMBER: '8',
        THOROUGHFARE_NAME: 'BAKER STREET',
        POST_TOWN: 'Y FENNI',
        POSTCODE: 'NP7 5BB',
        RPC: '1',
        X_COORDINATE: 329753.0,
        Y_COORDINATE: 214380.0,
        STATUS: 'APPROVED',
        LOGICAL_STATUS_CODE: '1',
        CLASSIFICATION_CODE: 'RD03',
        CLASSIFICATION_CODE_DESCRIPTION: 'Semi-Detached',
        LOCAL_CUSTODIAN_CODE: 6840,
        LOCAL_CUSTODIAN_CODE_DESCRIPTION: 'MONMOUTHSHIRE',
        COUNTRY_CODE: 'W',
        COUNTRY_CODE_DESCRIPTION: 'This record is within Wales',
        POSTAL_ADDRESS_CODE: 'D',
        POSTAL_ADDRESS_CODE_DESCRIPTION: 'A record which is linked to PAF',
        BLPU_STATE_CODE: '2',
        BLPU_STATE_CODE_DESCRIPTION: 'In use',
        TOPOGRAPHY_LAYER_TOID: 'osgb1000021003408',
        WARD_CODE: 'W05001775',
        PARISH_CODE: 'W04001057',
        LAST_UPDATE_DATE: '17/10/2016',
        ENTRY_DATE: '10/05/2001',
        BLPU_STATE_DATE: '06/09/2016',
        LANGUAGE: 'CY',
        MATCH: 0.4,
        MATCH_DESCRIPTION: 'NO MATCH',
        DELIVERY_POINT_SUFFIX: '1N'
      }
    }
  ]
}
